export const INSTALL_KEY = 'mokaab.install.v1';
export const SESSION_KEY = 'mokaab.install.session';
export const SUGGEST_AFTER_MS = 15000;
export const REMIND_AFTER_MS = 7 * 24 * 60 * 60 * 1000;

export function readInstallHistory() {
  try {
    const value = JSON.parse(localStorage.getItem(INSTALL_KEY) || '{}');
    return {count: Math.max(0, Number(value.count) || 0), lastShown: Number(value.lastShown) || 0, installed: value.installed === true};
  } catch { return null; }
}
export function writeInstallHistory(value) {
  try { localStorage.setItem(INSTALL_KEY, JSON.stringify(value)); return true; } catch { return false; }
}
export function canSuggestInstall(history, now = Date.now()) {
  return Boolean(history && !history.installed && history.count < 2 && (!history.lastShown || now - history.lastShown >= REMIND_AFTER_MS));
}
export function isStandalone() {
  return window.matchMedia('(display-mode: standalone)').matches || navigator.standalone === true;
}
export function canOfferOnPage() {
  const hash = window.location.hash.replace('#', '');
  if (!['', 'top', 'how', 'faq', 'kids', 'goal-planner', 'qcl-main'].includes(hash) || !document.querySelector('.qcl-hero')) return false;
  return document.visibilityState === 'visible'
    && !document.body.classList.contains('qgp-phone-active')
    && !document.querySelector('dialog[open], [aria-modal="true"], mokaab-support-launcher[data-open], .qcl-menu-toggle[aria-expanded="true"]')
    && !document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
}
export function installationPlatform() {
  const agent = navigator.userAgent;
  if (/iPhone|iPad|iPod/.test(agent) || (/Macintosh/.test(agent) && navigator.maxTouchPoints > 1)) return 'ios';
  if (/Android/.test(agent)) return 'android';
  return 'desktop';
}
